import React, { useState } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaSearch } from 'react-icons/fa';
import Data from '../../components/Data';
import ReactSelect from '../../components/ReactSelect';
import api from '../../services/api';
import '../../css/financeiro-parcela-pagar.css';

export default function RelatorioPagamentoOrcamento() {
    const token = localStorage.getItem('token');
    const empresa = localStorage.getItem("empresa");
    const [filtro, setFiltro] = useState({
        empresa: empresa,
    });

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Relatório de Pagamentos</h1>
                    </div>
                </div>
                <div className="fin-pp__card">
                    <form method="post" target="_blank" action={process.env.REACT_APP_API_URL + "/orcamento/relatorioPagamento"}>
                        <input type="hidden" name="token" value={token} />
                        <input type="hidden" name="empresa" value={empresa} />
                        <div className="fin-pp__filters" style={{ padding: '12px 16px' }}>
                            <div className="fin-pp__field">
                                <Data
                                    inputName="vencimento1"
                                    label="Data Vencimento"
                                    value={filtro.vencimento1}
                                    onChange={date => setFiltro({ ...filtro, ...{ "vencimento1": date } })}
                                />
                            </div>
                            <div className="fin-pp__field">
                                <Data
                                    inputName="vencimento2"
                                    label="até a Data Vencimento"
                                    value={filtro.vencimento2}
                                    onChange={date => setFiltro({ ...filtro, ...{ "vencimento2": date } })}
                                />
                            </div>
                            <div className="fin-pp__field" style={{ flex: 1 }}>
                                <label className="fin-pp__label">Cliente</label>
                                <ReactSelect
                                    id="cliente"
                                    name="cliente"
                                    value={{ value: filtro.cliente, label: filtro.nomeCliente }}
                                    onChange={e => setFiltro({ ...filtro, ...{ "cliente": e.value, "nomeCliente": e.label } })}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/participante',
                                            token: token,
                                            params: {
                                                nome: input,
                                                tipoCadastro: "cliente",
                                                situacaoRegistro: "ativo",
                                            }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map((registro) => {
                                                    var label = registro.codigo +
                                                        ' - ' + registro.nome +
                                                        (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                        (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                        (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                        (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                    return {
                                                        value: registro.id,
                                                        label: label
                                                    };
                                                });
                                                return options;
                                            })
                                            .catch(function (error) {});
                                    }}
                                />
                            </div>
                        </div>
                        <div className="fin-pp__modal-foot" style={{ borderTop: '1px solid var(--fin-brd)', padding: '12px 16px' }}>
                            <button type="submit" className="fin-pp__btn fin-pp__btn--primary">
                                <FaSearch size={16} style={{ marginRight: 8 }} /> Buscar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </ErpTemplate>
    );
}
